import template from './documents.html';
import controller from './documents.controller.js';

const profileDocumentsComponent = {
  restrict: 'E',
  bindings: {},
  controller,
  template
};

export default profileDocumentsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/profile/documents/documents.component.js
 **/